module.exports = __webpack_public_path__ + "media/images/thumbnails/thumb1-f225b1cd87c4a7026c083160abbeac12.jpg";